import { useEffect, useState } from 'react';

const messages = [
  '✦  Free gift with every order',
  '✦  Free shipping on orders over $24',
  '✦  Buy 2 packs — get 10% off automatically',
];

export const AnnouncementBar = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % messages.length), 3500);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="announcement-bar" className="bg-lum-text text-lum-bg text-[11px] uppercase tracking-[0.28em] py-2.5 text-center font-medium">
      <span key={idx} className="animate-fade-up inline-block">{messages[idx]}</span>
    </div>
  );
};
